import { merge } from '../../../helper';

import addClass from '../../../general/class/addClass';
import isEmptyObject from '../../../general/isEmpty/isEmptyObject';

import * as exElement from '../../../utils/element';
import * as exLink from '../../../utils/link';
import * as exButton from '../../button';

import withItemBody from './withItemBody';

// ----------------------------------------------------------------------------

function add(config: Record<string, any> = {}): Record<string, any> {
    const defConfig: Record<string, any> = {};
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    //
    const elements: Record<string, any> = {};

    // Create element (item)
    const elItem = exElement.create({
        merge: defConfig,
        tag: 'li',
    });
    elements.element = elItem;

    // ------------------------------------------------------------------------

    // If using link
    if (!isEmptyObject(defConfig.link)) {
        // Create element (link)
        const link = exLink.create({
            merge: withItemBody(defConfig.link),
            class: {
                new: 'dropdown-item',
            },
        });
        elItem.appendChild(link.element);
        elements.link = link;

        // If using subtitle
        if (defConfig.link.subtitle != null) {
            addClass(link.element, 'dropdown-item-rich');
        }
    }
    // If using button
    else if (!isEmptyObject(defConfig.button)) {
        // Create element (button)
        const button = exButton.create({
            merge: defConfig.button,
            class: {
                new: 'dropdown-item',
            },
        });
        elItem.appendChild(button.element);
        elements.button = button;
    }

    // ------------------------------------------------------------------------

    // Return
    return elements;
}

// ----------------------------------------------------------------------------

export default add;
